module.exports = __webpack_public_path__ + "0118891b72ed5252f37ddfc38e19cf5e.png";